<section>
  <div class="bg-gray-10 border rounded p-3 mb-3">
    <strong class="d-flex align-items-center text-md mb-2">
      <span class="ico ico-Users mr-2"></span>
      {{ 'wizards:entityWizards.company.nameStep.summaryTitle' | i18next }}
    </strong>

    <ul class="mb-0 pl-4">
      @for (item of summaryItems; track item) {
        <li
          class="text-sm"
          [class.mb-2]="!$last">
          {{ item }}
        </li>
      }
    </ul>
  </div>

  <mbs-input
    [id]="'company-name-input'"
    [label]="'wizards:entityWizards.company.nameStep.companyName' | i18next"
    [ngModel]="value().name"
    [placeholder]="'wizards:entityWizards.company.nameStep.companyNamePlaceholder' | i18next"
    [required]="true"
    (ngModelChange)="nameChangeHandler($event)"></mbs-input>
</section>

<ng-template
  #createModal
  let-close="close"
  let-dismiss="dismiss">
  <header class="modal-header mbs-modal_header">
    <div class="form-row">
      <div class="col">
        <h5 class="modal-title mbs-modal_title">{{ 'wizards:entityWizards.company.nameStep.createModal.title' | i18next }}</h5>
      </div>

      <div class="col-auto">
        <mbs-button
          aria-label="Close"
          [icon]="'ico ico-Close'"
          [isCtrl]="true"
          [type]="'dark'"
          (click)="dismiss()"></mbs-button>
      </div>
    </div>
  </header>

  <div class="modal-body">{{ 'wizards:entityWizards.company.nameStep.createModal.text' | i18next }}</div>

  <div class="modal-footer">
    <mbs-button
      [type]="'primary'"
      (click)="close(createResults.CreateAndContinue)">
      {{ 'wizards:entityWizards.company.nameStep.createModal.createAndContinue' | i18next }}
    </mbs-button>

    <mbs-button
      [type]="'primary'"
      (click)="close(createResults.CreateAndExit)">
      {{ 'wizards:entityWizards.company.nameStep.createModal.createAndExit' | i18next }}
    </mbs-button>

    <mbs-button
      [type]="'secondary'"
      (click)="dismiss()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </div>
</ng-template>
